import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from "./PrivateRoute";
import AuthRoutes from "./AuthRoutes";
import { DataProvider } from "./../context/DataContext";
import { ContextualHelpProvider } from "../context/ContextualHelpContext";
import ContextualHelpDrawer from "../components/help/ContextualHelpDrawer";

import LayoutApp from "../components/LayoutApp";
import Home from "../pages/home/Home";
import AdminHomeLayout from "../admin/home/AdminHomeLayout";
import GraphPageWrapper from "../components/semantic-graph/GraphPageWrapper";
import {
  TenantDashboard,
  SemanticConnections,
  SemanticDatabase,
  SemanticModels,
  SemanticEntities,
  SemanticDimensions,
  SemanticMetrics,
  SemanticWorkspace,
  SqlWorkbook,
  IcebergCatalog,
  IcebergMaintenance,
  AgentsOverview,
  AgentsModelsLLM,
  KnowledgeBasesOverview,
  VerifiedQueriesOverview,
  SecurityUsers,
  SecurityRoles,
  SecurityPolicies,
  SecurityGroups,
  SecuritySignupAllowlist,
  UserInvitesPage,
  AuditQueries,
  BillingPricing,
  BillingCreditConfig,
  BillingGlobalConsumption,
  BillingTenantAccount,
  BillingOperationPricing,
  BillingCreditPolicy,
  BillingSubscriptionPlans,
  ChartGenerationSettings,
  DeepAnalysisSettings,
  SqlRulesSettings,
  DashboardSettings,
  MyDashboards,
  DashboardDetail,
  InfrastructureCosts
} from "../admin/home/pages";

import { Login, Register, PasswordRecovery } from "../pages/auth/index";
import ConfirmUser from "../pages/auth/ConfirmUser/ConfirmUser";
import Enroll from "../pages/enroll/Enroll";
import Pricing from "../pages/pricing/Pricing";
import MarketplaceClaim from "../pages/marketplace/MarketplaceClaim";

const AppRouter = () => {
  return (
    <DataProvider>
      <ContextualHelpProvider>
      <Routes>
        <Route element={<Home />} path="/" exact />
        <Route path="/enroll" element={<Enroll />} />
        <Route path="/enroll/:token" element={<Enroll />} />
        <Route path="/precios" element={<Pricing />} />
        <Route path="/marketplace/claim" element={<MarketplaceClaim />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
        {/* Routes to redirect to dashboard if is authenticated, otherwise reder its child */}
        <Route element={<AuthRoutes />}>
          <Route path="/login" element={<Login />} exact />
          <Route path="/register" element={<Register />} />
          <Route path="/password/:type" element={<PasswordRecovery />} />
          <Route path="/confirm-user" element={<ConfirmUser />} />
        </Route>
        {/* Routes that render its child if is authenticated, otherwise navigate to login */}
        <Route element={<PrivateRoute />}>
          <Route path="/layautapp" element={<LayoutApp />} />
          {/* Mis tableros dentro del chat (mismo menú lateral de conversaciones). */}
          <Route path="/layautapp/tableros" element={<LayoutApp />} />
          <Route path="/layautapp/tableros/:dashboardId" element={<LayoutApp />} />
          <Route path="/semanticmodel" element={<LayoutApp />} />
          <Route path="/admin/home" element={<AdminHomeLayout />}>
            <Route index element={<Navigate to="/admin/home/panel" replace />} />
            <Route path="panel" element={<TenantDashboard />} />
            <Route path="tableros" element={<MyDashboards />} />
            <Route path="tableros/:dashboardId" element={<DashboardDetail />} />
            <Route path="semantic-models/conexiones" element={<SemanticConnections />} />
            <Route path="semantic-models/base-datos" element={<SemanticDatabase />} />
            <Route path="semantic-models/modelos" element={<SemanticModels />} />
            <Route path="semantic-models/modelos/:modelId/graph" element={<GraphPageWrapper />} />
            {/* Entidades ya no vive en el menú principal -- solo se llega acá
                haciendo clic en el nombre de una base de datos semántica
                (ver SemanticDatabaseCard.js), con :databaseId acotando el
                listado a las tablas de esa base. */}
            <Route path="semantic-models/base-datos/:databaseId/entidades" element={<SemanticEntities />} />
            <Route path="semantic-models/dimensiones" element={<SemanticDimensions />} />
            <Route path="semantic-models/metricas" element={<SemanticMetrics />} />
            <Route path="workspaces/espacios-analisis" element={<SemanticWorkspace />} />
            <Route path="workspaces/sql-workbook" element={<SqlWorkbook />} />
            <Route path="semantic-models/catalogo-iceberg" element={<IcebergCatalog />} />
            <Route path="semantic-models/mantenimiento-tablas" element={<IcebergMaintenance />} />
            <Route path="agentes/listado" element={<AgentsOverview />} />
            <Route path="agentes/bases-conocimiento" element={<KnowledgeBasesOverview />} />
            <Route path="agentes/consultas-verificadas" element={<VerifiedQueriesOverview />} />
            <Route path="agentes/modelos-llm" element={<AgentsModelsLLM />} />
            <Route path="seguridad/usuarios" element={<SecurityUsers />} />
            <Route path="seguridad/roles" element={<SecurityRoles />} />
            <Route path="seguridad/politicas" element={<SecurityPolicies />} />
            <Route path="seguridad/grupos" element={<SecurityGroups />} />
            <Route path="seguridad/registro-permitido" element={<SecuritySignupAllowlist />} />
            <Route path="seguridad/invitaciones" element={<UserInvitesPage />} />
            <Route path="auditoria/consultas" element={<AuditQueries />} />
            <Route path="creditos/cuenta" element={<BillingTenantAccount />} />
            <Route path="creditos/precios" element={<BillingPricing />} />
            <Route path="creditos/precios-operacion" element={<BillingOperationPricing />} />
            <Route path="creditos/configuracion" element={<BillingCreditConfig />} />
            <Route path="creditos/politica" element={<BillingCreditPolicy />} />
            <Route path="creditos/planes" element={<BillingSubscriptionPlans />} />
            <Route path="creditos/consumo-global" element={<BillingGlobalConsumption />} />
            <Route path="sistema/generacion-graficas" element={<ChartGenerationSettings />} />
            <Route path="sistema/analisis-profundo" element={<DeepAnalysisSettings />} />
            <Route path="sistema/generacion-tableros" element={<DashboardSettings />} />
            <Route path="sistema/reglas-sql" element={<SqlRulesSettings />} />
            <Route path="sistema/costos-infraestructura" element={<InfrastructureCosts />} />
          </Route>
        </Route>
      </Routes>
      <ContextualHelpDrawer />
      </ContextualHelpProvider>
    </DataProvider>
  );
};

export default AppRouter;
